<template>
	<div>
		Vehicle Events = {{ id }}
		<ul v-if="vehicleEvents">
			<li v-for="event in vehicleEvents.items" :key="event.id">
				<VehicleEventsItem :event="event" />
			</li>
		</ul>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import VehicleEventsItem from './vehicle-events-item-view.vue';

export default {
	name: 'VehicleEvents',
	components: {
		VehicleEventsItem
	},
	created() {
		this.getVehicleEventsAction(this.id).then(ve => {
			this.vehicleEvents = ve;
		});
	},
	props: {
		id: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			vehicleEvents: {}
		};
	},
	methods: {
		...mapActions('vehicle', ['getVehicleEventsAction'])
	}
};
</script>

<style lang="scss" scoped></style>
